import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { PATH } from '../../../constants/path';

import LocalizedNavLink from '../../router/LocalizedNavLink';

import './AccountNavComponent.scss';

class AccountNavComponent extends React.Component {
    render() {
        const { i18n } = this.props;

        return (
            <nav className="account-nav" id="account-nav">
                <LocalizedNavLink
                    to={PATH.ACCOUNT_JACKPOT_PATH}
                    title={i18n.CASHBACK}
                    activeClassName="actif"
                    exact>
                    <span>{i18n.CASHBACK}</span>
                </LocalizedNavLink>
                <LocalizedNavLink
                    to={PATH.ACCOUNT_PAYMENTS_PATH}
                    title={i18n.PAYMENTS}
                    activeClassName="actif"
                    exact>
                    <span>{i18n.PAYMENTS}</span>
                </LocalizedNavLink>
                <LocalizedNavLink
                    to={PATH.ACCOUNT_EBONS_PATH}
                    title={i18n.EBONS}
                    activeClassName="actif"
                    exact>
                    <span>{i18n.EBONS}</span>
                </LocalizedNavLink>
                <LocalizedNavLink
                    to={PATH.ACCOUNT_PROFILE_PATH}
                    title={i18n.PROFILE}
                    activeClassName="actif"
                    exact>
                    <span>{i18n.PROFILE}</span>
                </LocalizedNavLink>
                <LocalizedNavLink
                    to={PATH.ACCOUNT_MESSAGES_PATH}
                    title={i18n.MESSAGES}
                    activeClassName="actif">
                    <span>{i18n.MESSAGES}</span>
                </LocalizedNavLink>
            </nav>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.NAV
    };
};

export default withRouter(connect(mapStateToProps)(AccountNavComponent));



// WEBPACK FOOTER //
// ./src/components/pages/account/AccountNavComponent.js